import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports')({
  beforeLoad: () => getTitleContextSlice('Reports', { hideBreadcrumbs: true }),
  staticData: {
    owner: CodeOwner.Analytics,
  },
});
